import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import ProfileTitle from '../../layout/mobile/profile/ProfileTitle';
import ProductListSkeleton from './components/loadingState/productListSkeleton';
import ProductList from './components/ProductList';
import EmptyState from './components/emptyState/emptyState';
import ErrorState from '../../common/errorState/errorState';
import Message from '../../common/Message';

import PurchaseIcon from '../../common/icons/purchaseIcon';

import { getProducts } from '../../../redux/actions/ProductActions';

import {
  ordersMTOAlertPE,
  ordersListMessages,
} from '../../../constants/Messages';
import { showOrdersInformativeAlert } from '../../../helpers/orders/OrdersHelper';

const useStyles = makeStyles(() => ({
  container: {
    height: 'auto',
  },
  alertContainer: {
    marginBottom: 20,
  },
}));

const MyPurchases = ({ ...props }) => {
  const { mobile } = props;
  const products = useSelector((state) => state.productReducer.products);
  const loading = useSelector((state) => state.productReducer.loading);
  const error = useSelector((state) => state.productReducer.error);
  const finishedLoading = useSelector((state) => state.productReducer.finished);
  const dispatch = useDispatch();
  const classes = useStyles({ mobile });

  useEffect(() => {
    if (!finishedLoading) dispatch(getProducts());
  }, []);

  return (
    <Box className={classes.container}>
      <ProfileTitle
        mobile={mobile}
        subtitle={ordersListMessages.subtitle}
        title={<strong>{ordersListMessages.title}</strong>}
        icon={<PurchaseIcon size="30px" color="#6A148E" />}
      />
      {loading && <ProductListSkeleton mobile={mobile} />}
      {products.length !== 0 && finishedLoading && (
        <React.Fragment>
          {showOrdersInformativeAlert() && (
            <div className={classes.alertContainer}>
              <Message severity="info" message={ordersMTOAlertPE} />
            </div>
          )}
          <ProductList mobile={mobile} products={products} />
        </React.Fragment>
      )}
      {!products.length && finishedLoading && !error && <EmptyState />}
      {!products.length && finishedLoading && error && (
        <ErrorState mobile={mobile} title={ordersListMessages.error} />
      )}
    </Box>
  );
};

MyPurchases.propTypes = {
  mobile: PropTypes.bool,
};

export default MyPurchases;
